import { CatalogList } from './CatalogList';

/**
 * Mounts the storefront catalog into #sf-catalog-root.
 * Loaded by Modules/Storefront/Catalog/Views/StorefrontCatalogIndex.cshtml.
 */
function mount(): void {
    const root = document.getElementById('sf-catalog-root');
    if (!root) return;
    new CatalogList(root);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
} else {
    mount();
}

export default {};
